import { types } from '../constants';

export const fetchAllAccidentsForBranchDispatch = (branchId) => ({
  type: types.FETCH_ALL_ACCIDENTS_FOR_BRANCH,
  branchId
});

export const fetchAllAccidentsForCompanyDispatch = (companyId) => ({
  type: types.FETCH_ALL_ACCIDENTS_FOR_COMPANY,
  companyId
});

export const searchTermChangeForAllAccidents = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_ACCIDENTS,
  searchTerm
});

export const openCreateAccidentDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_ACCIDENT_DIALOG,
  open
});

export const openEditAccidentDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_ACCIDENT_DIALOG,
  open
});

export const handleAccidentInputChangeDispatch = (value, inputFieldName) => ({
  type: types.INPUT_CHANGE_CREATE_ACCIDENT_FORM,
  value,
  inputFieldName
});

export const submitAccidentDispatch = (accident, mode) => ({
  type: types.SUBMIT_ACCIDENT,
  accident,
  mode
});

export const accidentEditClickDispatch = (accident) => ({
  type: types.EDIT_ACCIDENT,
  accident
});

export const showDeleteOrActivateAccidentDialogStatChanged = (
  open,
  accident,
  status
) => ({
  type: types.DEACTIVATE_OR_DELETE_ACCIDENT_DIALOG,
  open,
  accident,
  status
});

export const confirmDeleteDeactivateAccidentDispatc = (payload) => ({
  type: types.DEACTIVATE_OR_DELETE_ACCIDENT,
  payload
});

export const removeAccidentAttachment = (attachment) => ({
  type: types.REMOVE_ACCIDENT_ATTACHMENT,
  attachment
});

export const fetchExistingAttachmentsForTheAccidentDispatch = (
  domainTypeId,
  parentId,
  loggedInUserId
) => ({
  type: types.LOAD_ATTACHMENTS_FOR_ACCIDENT,
  domainTypeId,
  parentId,
  loggedInUserId
});
